import Api from "../api";
import { UseEvent } from "./index";
import _ from "lodash";

const UseSlot = () => {
  let param = {};
  const event = UseEvent();

  const getVendor = (nav, lang) => {
    param.catid = nav.get("catid");
    param.afterLoad = false;
    param.mod = nav.get("mod") || "";
    param.mobile = true;
    param.lang = lang === "ka" ? "en" : lang;
    param.operator = nav.get("operator");
    param.game = nav.get("game");
    param.provider = nav.get("provider");
    switch (nav.get("catid")) {
      /*case '47': //hasksaw
        //param.mobile = false;
        param = _.omit(param, 'mobile');
        break;*/
      case "36":
        param.portalID = 2;
        break;
      case "evolution":
        param.lang = lang;
        break;
      case "73":
        param.lang = lang;
        break;
      case "30":
        param.afterLoad = true;
        //param.id = "<?= htmlentities($_GET['id']) ?>";
        break;
      case "7": // betsoft
      case "8": // Tom Horn
      case "9": // Mr. Slotty
      case "10": // Amatic
      case "13": // Booming games
      case "4": // microgaming
      case "27": // PRAGMATIC
      case "35": // WAZDAN
      case "14": // Endorphina
      case "63": // Endorphina
        param.vendor = "softgamings";
        param.providerID = nav.getParams()["provider"] || null;
        param.gameID = nav.getParams()["game"] || null;
        break;
      case "16": // GAME ART
        param.vendor = "game_art";
        break;
      case "12": // Betsense
        param.vendor = "Betsense";
        break;
      case "20": // netent
        param.vendor = "netent";
        param.afterLoad = true;
        //delete param.provider;
        break;
      case "60":
      case "61":
        param.gameID = nav.getParams()["game"] || null;
        param.table = nav.getParams()["game"] || null;
        break;
      case "67":
        param.vendor = "softgamings";
        param.providerID = nav.getParams()["provider"] || null;
        param.gameID = nav.getParams()["game"] || null;
        break;
    }
    return param;
  };
  const play = ({
    URL,
    param,
    signIn,
    i18n,
    balanceWindow,
    showBalanceWindow,
    catid,
    frame,
    lang,
    platform = "web",
  }) => {
    if (platform === "web") {
      delete param.mobile;
    }
    Api.Slots.PlaySlot({
      url: URL,
      params: param,
    }).then((response) => {
      let slData = response.data;
      if (slData.status === 1) {
        if (parseInt(catid) === 30) {
          const url =
            slData?.data?.directUrl +
            `&clientType=casino&clientPlatform=${platform}&language=EN&depositUrl=https://' + window.location.hostname + '/m/' + i18n.language + '/cashier?vendor=playTech&lobbyUrl=https://' + window.location.hostname + '/m/' + i18n.language + '/slots?30`;
          frame.setAttribute("src", url);
          frame.setAttribute("allowfullscreen", true);
          listener(slData.key);
        } else {
          if (!param.afterLoad) {
            if (
              slData.data !== null &&
              (slData.data.result === 0 || slData.data.status === 200)
            ) {
              if (param.mod === "test") {
                switch (param.catid) {
                  case "evolution":
                      frame.setAttribute("src", slData.data.url_embed);
                    break;
                  default:
                      frame.setAttribute("src", slData.data.url);
                    break;
                }
              } else {
                switch (param.catid) {
                  default:
                    frame.setAttribute("src", slData.data.url);
                    listener(slData.key);
                    break;
                  case "7": // betsoft
                  case "8": // Tom Horn
                  case "9": // Mr. Slotty
                  case "10": // Amatic
                  case "13": // Booming games
                  case "4": // microgaming
                  case "27": // PRAGMATIC
                  case "35": // WAZDAN
                  case "14": // Endorphina
                    if (slData.data.type === "HTML") {
                      document
                        .getElementById("playSlotFrame")
                        .contentWindow.document.write(slData.data.url);
                    } else {
                      frame.setAttribute("src", slData.data.url);
                      listener(slData.key);
                    }
                    break;
                  case "12": // BETSENSE
                    if (param.game === "rugbyscrum") {
                      const u =
                        "https://leader-bet.betsense.ge/rugbyscrum?lang=" +
                        param.lang +
                        "&token=" +
                        slData.data.url.split("=")[2];
                      frame.setAttribute("src", u);
                    } else {
                      frame.setAttribute("src", slData.data.url);
                    }
                    listener(slData.key);
                    break;
                  case "16": // GAME ART
                    frame.setAttribute("src", slData.data.url);
                    frame.setAttribute("allowfullscreen", true);
                    listener(slData.key);
                    break;
                  case "66": // EGT DIGITAL
                    frame.setAttribute("src", slData.data.url);
                    //frame.setAttribute("allowfullscreen", true);
                    frame.setAttribute("allow", "autoplay *; screen-wake-lock *; fullscreen *");
                    listener(slData.key);
                    break;
                }
              }
              if (
                balanceWindow &&
                typeof param.freespin === "undefined" &&
                param.mod !== "test"
              ) {
                showBalanceWindow();
              }
            } else {
              alert(i18n.t("თამაშის გაშვება დროებით შეუძლებელია"));
            }
          } else {
            if (
              balanceWindow &&
              typeof param.freespin === "undefined" &&
              param.mod !== "test"
            ) {
              showBalanceWindow();
            }
          }
        }
      } else if (slData.status === 2) {
        alert(slData.desc);
      } else if (slData.status === 3) {
        signIn.open();
      } else {
        alert(i18n.t("შეცდომა! გთხოვთ სცადოთ მოგვიანებით"));
      }
    });
  };
  const listener = (hash) => {
    Api.Slots.Listener({ hash: hash })
      .then(() => {
        window.timeout = setTimeout(function () {
          listener(hash);
        }, 7000);
      })
      .catch(
        () =>
          (window.timeout = setTimeout(function () {
            listener(hash);
          }, 7000))
      );
  };
  const deposit = (params = {}) => {
    event.emit("lb-event", {
      type: "GameDeposit",
      ...params,
    });
  };
  const getLastPlayed = async () => {
    const res = await Api.Slots.LastPlayed();
    if (res.data?.data?.length > 0) {
      return res.data.data.map((i) => ({
        ...i,
        operator_id: i.operator,
        name_en: i.name,
      }));
    }
    return [];
  };
  const popular = ({ limit = 15 }) => {
    return Api.Slots.popular({ limit: limit });
  };
  const returnMoney = (operator) => {
    return Api.Slots.returnMoney(operator);
  };
  const checkBetMarketGames = ({ name }) => {
    return Api.Slots.checkBetMarketGames({ name: name });
  };
  const buyBetMarketGame = ({ id, operator, discountId = null }) => {
    return Api.Slots.buyBetMarketGame({ id, operator, discountId });
  };
  return {
    getVendor,
    play,
    deposit,
    getLastPlayed,
    popular,
    returnMoney,
    checkBetMarketGames,
    buyBetMarketGame,
  };
};
export default UseSlot;
